"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePostAmountTypeEnum = void 0;
var InvoicePostAmountTypeEnum;
(function (InvoicePostAmountTypeEnum) {
    InvoicePostAmountTypeEnum["Currency"] = "Currency";
    InvoicePostAmountTypeEnum["MinDeb"] = "MinDeb";
    InvoicePostAmountTypeEnum["Percent"] = "Percent";
})(InvoicePostAmountTypeEnum = exports.InvoicePostAmountTypeEnum || (exports.InvoicePostAmountTypeEnum = {}));
